// constants/urls.ts
export const URL = {
  HOME: "/",
  ACCOUNT: "/account",
  ACCOUNT_NETWORK_CREATE: "/account/network/create",
  ACCOUNT_NETWORK_VIEW: "/account/network/:providerNetworkId",
  LOGIN: "/login",
  MEDICAL_CLAIMS: "/medical/claims",
  MEDICAL_CLAIM_LIST: "/medical/claims/list",
  NOTIFICATIONS: "/notifications",
  PA_SEARCH: "/pa/search",
  PA_CREATE: "/pa/create",
  PA_CASE: "/pa/case",
  PA_CREATE_CASE_DRAFT_SUCCESS: "/pa/case_draft/success",
  PA_CASE_DRAFT_ACCESS: "/pa/case_draft/access",
  PHARMACY: "/pharmacy",
  PHARMACY_SUBMIT: "/pharmacy/submit",
  PAGE_NOT_FOUND: "/404",
  PATIENT_LOOKUP: "/patient/lookup",
  PATIENT_COVERAGE_SEARCH: "/patient/coverage/search",
  PROVIDER_DOCUMENTS: "/provider/documents",
  CRITERIA: "/criteria",
};

export const CLIENT_URL = {
  HOME: "/client/:Client",
  ACCOUNT: "/client/:Client/account",
  ACCOUNT_NETWORK_CREATE: "/client/:Client/account/network/create",
  ACCOUNT_NETWORK_VIEW: "/client/:Client/account/network/:providerNetworkId",
  LOGIN: "/client/:Client/login",
  MEDICAL_CLAIMS: "/client/:Client/medical/claims",
  MEDICAL_CLAIM_LIST: "/client/:Client/medical/claims/list",
  NOTIFICATIONS: "/client/:Client/notifications",
  PA_SEARCH: "/client/:Client/pa/search",
  PA_CREATE: "/client/:Client/pa/create",
  PA_CASE: "/client/:Client/pa/case",
  PA_CREATE_CASE_DRAFT_SUCCESS: "/client/:Client/pa/case_draft/success",
  PA_CASE_DRAFT_ACCESS: "/client/:Client/pa/case_draft/access",
  PHARMACY: "/client/:Client/pharmacy",
  PHARMACY_SUBMIT: "/client/:Client/pharmacy/submit",
  PAGE_NOT_FOUND: "/client/:Client/404",
  PATIENT_LOOKUP: "/client/:Client/patient/lookup",
  PATIENT_COVERAGE_SEARCH: "/client/:Client/patient/coverage/search",
  PROVIDER_DOCUMENTS: "/client/:Client/provider/documents",
  CRITERIA: "/client/:Client/criteria",
};
